<template>
    <div class="customRouteTimePickerComponent" v-on:click="toggleModal(true)" v-bind="$attrs">
      <div class="customRouteTimePickerComponentContent">
        <div class="input-time-position" v-if="arrivalTime">
          {{ customRouteFullTime.split(':')[0].trim() + ':' + customRouteFullTime.split(':')[1].trim() }}
        </div>
      </div>
      <template v-if="timePickerModal">
          <div class="custom-route-time-modal-mask">
            <div class="modal-wrapper" >
              <div class="modal-content">
                <div class="modal-header justify-content-end">
                  <button type="button"
                          class="custom-route-close-button"
                          v-on:click.stop="closeModal(false)">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body d-flex align-items-center">
                  <div class="customRouteTimePickerModalText">
                    <h5 class="m-0 pe-3">{{$t('time')}}</h5>
                  </div>
                  <div class="customRouteTimePickerModalInput">
                    <select :value="currentHours.length === 1 ? '0' + currentHours : currentHours" @change="changeHours">
                      <option v-for="(hour) in hours" :value="hour" :key="hour">
                        {{ hour }}
                      </option>
                    </select>
                    <span>:</span>
                    <select :value="currentMinutes.length === 1 ? '0' + currentMinutes : currentMinutes" @change="changeMinutes">
                      <option v-for="(minute) in minutes" :value="minute" :key="minute">
                        {{ minute }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </template>
    </div>
  <div v-if="timePickerModal" id="closeCustomRouteTimepickerModal" v-on:click="closeModal(false)"></div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import './customRouteTimePicker.scss';

export default defineComponent({
  name: 'CustomRouteTimePickerComponent',
  emits: ['getCustomArrivalTime'],
  props: {
    pickupTime: {
      type: Boolean,
      required: false,
    },
    arrivalTime: {
      type: String
    },
  },


  data() {
    return {
      currentHours:'',
      currentMinutes: '',
      hours: [],
      minutes: [],
      timePickerModal: false,
      currentTime: '',
    }
  },

  watch: {
    arrivalTime(newValue, oldValue) {
      if ( this.arrivalTime ) {
        this.currentHours = newValue.split(':')[0].toString();
        this.currentMinutes = newValue.split(':')[1].toString();
      } else {
        this.currentHours = '10';
        this.currentMinutes = '00';
      }

    },
    customRouteFullTime(newVal, oldVal) {
      this.$emit('getCustomArrivalTime', {value: newVal});
    }
  },

  created() {
    let hourArray = [];
    let minutesArray = [];
    let date = new Date();
    let hour = date.getHours();
    let minutes = date.getMinutes();
    for (let i = 0; i < 24; i++){
      let iToString = i.toString();
      // @ts-ignore
      hourArray.push(iToString.length < 2 ? '0'+iToString : iToString);
    }
    for (let i = 0; i < 60; i++){
      let iToString = i.toString();
      // @ts-ignore
      minutesArray.push(iToString.length <  2 ? '0'+iToString : iToString);
    }
    this.hours = hourArray;
    this.minutes = minutesArray;


    if (this.arrivalTime) {
      this.currentHours = this.arrivalTime.split(':')[0].toString();
      this.currentMinutes = this.arrivalTime.split(':')[1].toString();
    } else {
      this.currentHours = '10';
      this.currentMinutes = '00';
    }

  },
  methods: {
    toggleModal: function (value) {
      this.timePickerModal = value;
    },
    closeModal: function (value) {
      this.timePickerModal = value;
    },
    changeHours(e) {
      this.currentHours = e.target.value;
    },
    changeMinutes(e) {
      this.currentMinutes = e.target.value;
    },
  },

  computed: {
    customRouteFullTime() {
      let pickedTime = `${this.currentHours.length < 2 ? '0'+this.currentHours : this.currentHours}:${this.currentMinutes.length < 2 ? '0'+this.currentMinutes : this.currentMinutes}`;
      return pickedTime;
    }
  },

});


</script>